export default __webpack_public_path__ + "static/media/wichita1.3439a507.jpeg";